import * as React from 'react'
import { styling } from 'common/utils'
import { DynamicCx } from 'common/types'
import { VerticalContext } from 'common/context'
import { isWindowService } from 'common/constants'
import Gnb from './Gnb'
import Lnb from './Lnb'
import * as s from './header.scss'

interface OwnProps {
  cx?: DynamicCx
}

type Props = OwnProps

const Header: React.SFC<Props> = ({ cx }) => (
  <div className={cx('header')}>
    <div className={cx('@header_fix')}>
      <Gnb />
      <VerticalContext.Consumer>
        {({ vertical, pathname }) => {
          if (isWindowService(pathname) || pathname.includes('/outlink')) {
            return <Lnb {...{ vertical }} />
          }
        }}
      </VerticalContext.Consumer>
    </div>
  </div>
)

const styled = styling(s)(Header)
export default styled
